<template>
  <v-container>

    <v-data-table
      :headers="well_headers"
      :items="well_list"
      multi-sort
      class="elevation-1"
      :items-per-page="-1" :hide-default-footer="true"
    >
      <template #body="{items, headers}">
        <tr v-for="(item, idx, i) in items" :key="idx">

          <td v-for="(header, key) in headers" :key="key" class="text-start">

            <v-data-table v-if=" header.value==='probes' " dense
                          :headers="probe_headers" :items="item[header.value]"
                          :items-per-page="-1" :hide-default-footer="true" :hide-default-header="true">

            </v-data-table>

            <!--            <div>-->
            <!--              Hallo |{{key}}|{{header.value=='probes'}}| {{item[header.value]}}-->
            <!--            </div>-->

            <!--            <v-edit-dialog v-else-->
            <!--              :return-value.sync="item[header.value]"-->
            <!--              @save="save"-->
            <!--              @cancel="cancel"-->
            <!--              @open="open"-->
            <!--              @close="close"-->
            <!--            >-->
            <template v-else>{{item[header.value]}}</template>

            <!--              <template v-slot:input>-->
            <!--                <v-text-field-->
            <!--                  v-model="item[header.value]"-->
            <!--                  label="Edit"-->
            <!--                  single-line-->
            <!--                ></v-text-field>-->
            <!--              </template>-->
            <!--            </v-edit-dialog>-->
          </td>

        </tr>
      </template>
    </v-data-table>

    <hr/>


    <!--    <v-data-table-->
    <!--      :headers="well_headers" :items="items" multi-sort-->
    <!--      :items-per-page="-1" :hide-default-footer="true"-->
    <!--      class="elevation-1"-->
    <!--    >-->


    <!--    </v-data-table>-->
  </v-container>
</template>

<script>

	import {
		VDataTable, VEditDialog, VTextField
	} from 'vuetify'

	export default {
		name: "well-list",

		components: {
			VDataTable, VEditDialog, VTextField
		},

		data: function () {
			return {
				well_headers: [
					{text: "Well #", align: 'start', sortable: true, value: 'well_num',},
					{text: "W", align: 'start', sortable: true, value: 'title',},
					// {text: "Sample", align: 'start', sortable: true, value: 'sample',},
					// {text: "Probes", align: 'start', sortable: false, value: 'probes',},
				],

				probe_headers: [
					{text: "Name", align: 'start', sortable: true, value: 'name',},
					{text: "Dye", align: 'start', sortable: true, value: 'dye',},
				],

				items: [
					{
						well_num: 1, well_name: "A1", sample: "sample1",
						probes: [
							{name: "TN6_GENE1", dye: "FAM"},
							{name: "TN6_GENE2", dye: "ROX"},
						],
					},
					{
						well_num: 2, well_name: "A2", sample: "sample2",
						probes: [
							{name: "TN6_GENE1", dye: "FAM"},
							{name: "TN6_GENE2", dye: "ROX"},
						],
					},

					{
						well_num: 3, well_name: "B1", sample: "sample1",
						probes: [
							{name: "TN6_GENE1", dye: "FAM"},
							{name: "TN6_GENE2", dye: "ROX"},
						],
					}
				]
			}
		},

		props: {
			well_list: {type: Array, default: () => [],},
		},

		watch: {
			well_list: function (new_value, old_value) {
				console.debug('WellListComponent.watch.well_list()')
			},
		},

		methods: {
			close: function () {

			},

			save: function () {

			},

			open: function () {

			},

			cancel: function () {

			},


		}
	}
</script>

<style scoped>

</style>